import { FONT_DATA, FONT_WEIGHT } from "const/font/font";
import { THEME_COLOR } from "const/theme/theme";
import { useEffect } from "react";
import useDarkModeStore from "store/useDarkModeStore";

export const SetupStyle = () => {
  const { isDarkMode } = useDarkModeStore();

  useEffect(() => {
    const root = document.documentElement;
    for (let key in THEME_COLOR) {
      root.style.setProperty(
        key,
        THEME_COLOR[key as keyof typeof THEME_COLOR][
          isDarkMode ? "dark" : "light"
        ]
      );
    }
  }, [isDarkMode]);

  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";

    FONT_DATA.forEach((font) => {
      font.weights.forEach((weight) => {
        const fontFace = `
          @font-face {
            font-family: '${font.name}';
            src: url('/assets/font/${font.key}/${font.key}-${weight}.${
          font.extension
        }') format('truetype');
            font-weight: ${FONT_WEIGHT[weight]};
            font-style: ${weight.includes("Italic") ? "italic" : "normal"};
          }
        `;
        style.appendChild(document.createTextNode(fontFace));
      });
    });

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return null;
};
